import script from "./ButtonDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDownload.vue?vue&type=script&setup=true&lang=js"

import "./ButtonDownload.vue?vue&type=style&index=0&id=7d29b6cd&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d29b6cd"]])

export default __exports__